const YOUTUBE_VIDEO_ID_REGEX = /^[A-Za-z0-9_-]{11}$/;

const parseUrl = (rawUrl: string): URL | null => {
  const value = rawUrl.trim();
  if (!value) return null;

  try {
    return new URL(value);
  } catch {
    try {
      // Support pasted values like "www.youtube.com/watch?v=..." without protocol.
      return new URL(`https://${value}`);
    } catch {
      return null;
    }
  }
};

const isYouTubeHost = (hostname: string): boolean => {
  const normalized = hostname.toLowerCase();
  return normalized === 'youtu.be' || normalized.endsWith('.youtu.be') || normalized === 'youtube.com' || normalized.endsWith('.youtube.com');
};

const isVideoId = (value: string | null | undefined): value is string => {
  return Boolean(value && YOUTUBE_VIDEO_ID_REGEX.test(value));
};

export const extractYouTubeVideoId = (rawUrl: string): string | null => {
  const parsed = parseUrl(rawUrl);
  if (!parsed || !isYouTubeHost(parsed.hostname)) {
    return null;
  }

  if (parsed.hostname.includes('youtu.be')) {
    const shortId = parsed.pathname.split('/').filter(Boolean)[0];
    return isVideoId(shortId) ? shortId : null;
  }

  const queryId = parsed.searchParams.get('v') ?? parsed.searchParams.get('vi');
  if (isVideoId(queryId)) {
    return queryId;
  }

  const segments = parsed.pathname.split('/').filter(Boolean);
  for (const segment of segments) {
    if (isVideoId(segment)) {
      return segment;
    }
  }

  return null;
};
